import { useEffect } from 'react';

import { EventType } from './eventTracking';

export function useEventHandler(eventType: EventType, handler: (payload: object) => void) {
  useEffect(() => {
    const handleMessage = (message: MessageEvent) => {
      const { data } = message;

      if (typeof data === 'object') {
        if (data.type === eventType) {
          handler(data);
        }
      }
    };

    window.addEventListener('message', handleMessage);

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [eventType, handler]);
}